<template>
  <div>
    <!--轮播图-->
    <div id="fy_banner" class="carousel slide" data-ride="carousel">
      <!-- Indicators -->
      <ol class="carousel-indicators">
        <li data-target="#fy_banner" data-slide-to="0" class="active"></li>
        <li data-target="#fy_banner" data-slide-to="1"></li>
        <li data-target="#fy_banner" data-slide-to="2"></li>
      </ol>

      <!-- Wrapper for slides -->
      <!--        <b-carousel></b-carousel>-->
      <div class="carousel-inner" role="listbox">
        <div class="item" :class="{'active': index === 0}" v-for="(url,index) in bannerList">
          <img :src="url" alt="轮播图" class="img-responsive">
          <div class="carousel-caption">
          </div>
        </div>
      </div>
    </div>
    <!--/轮播图-->
  </div>
</template>

<script>
  import './../assets/css/fy_banner.css'
  import bannerList from "../assets/conf/banner"
    export default {
        name: "fy_banner",
        data() {
            return {
                bannerList: bannerList
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_banner.vue